<style lang="less">
@import "../less/common.less";
.el-select-dropdown {
  z-index: 2007 !important;
}
#timeSetID {
  .el-dialog {
    width: 50% !important;
    max-width: 620px;
    // min-height: 400px;
  }
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__body {
    // padding: 12px 30px;
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    p {
      margin-block-start: 0em !important;
      margin-block-end: 0em !important;
      text-align: left;
      line-height: 20px;
    }
    .type-set {
      margin-bottom: 20px;
    }
    .time-btn-set {
      text-align: center;
      margin: 2em;
    }
    .time-btn-set.time-picker {
      text-align: left;
      .el-input {
        width: 100px;
      }
    }
    .dialog-footer {
      padding-top: 50px;
      text-align: center;
    }
  }
}
</style>
<template>
  <el-dialog id="timeSetID"
             class="timeSet"
             title="设置"
             :visible.sync="timeSetDialogVisible"
             width="70%"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             append-to-body>
    <div id="timeSetBody">
      <template v-if="radio==2||radio==3">
        <h4>分类名称显示</h4>
        <el-radio-group class="type-set"
                        v-model="redioTypes"
                        @change="changeType">
          <el-radio :label="1">中类显示</el-radio>
          <el-radio :label="0">小类显示</el-radio>
        </el-radio-group>
        <h4>时间节点设置</h4>
        <p>节点后销售数据单独展示，总销售包含节点后销售数据</p>
        <div class="time-btn-set time-picker">
          <span>下午：</span>
          <el-time-select placeholder="起始时间"
                          v-model="timeFive"
                          size="medium"
                          @change="timeFiveChange"
                          :clearable="false"
                          :picker-options="{
                            start: '15:00',
                            step: '2:00',
                            end: '17:00'
                          }">
          </el-time-select>
          <!-- <el-time-picker v-model="timeFive"
                          size="medium"
                          :picker-options="{selectableRange: '15:00:00 - 23:59:59'}"
                          :clearable="false"
                          format="HH:mm"
                          placeholder="时间节点">
          </el-time-picker> -->
        </div>
      </template>
      <template v-if="radio!=2">
        <h4>时间段设置</h4>
        <p>1小时：从6点起每隔1小时展示时间段数据。例：6点、7点</p>
        <p>半小时：从6点起每隔半小时展示时间段数据。例：6点、6点半</p>
        <!-- <p>自定义：自定义输入时间段取值，如：00：45，则表示为每45分钟展示时间段数据。例：6点、6点45</p> -->
        <div class="time-btn-set">
          <el-radio-group v-model="type"
                          size="medium"
                          slot="reference"
                          @change="saveRealTime">
            <el-radio-button :label="60">1小时</el-radio-button>
            <el-radio-button :label="30">半小时</el-radio-button>
            <!-- <el-radio-button :label="2">
            <span @click="showDays(2)">自定义</span>
          </el-radio-button> -->
          </el-radio-group>
        </div>
      </template>
      <div slot="footer"
           class="dialog-footer">
        <!-- <el-button type="primary"
                   @click="saveRealTime"
                   :loading="loadingTime">保存</el-button> -->
        <el-button size="small"
                   @click="closeTimeSet(0)">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import setApi from "@/api/api-set";
import { Message } from "element-ui";
export default {
  props: {
    radio: {
      type: Number,
      default: 1
    },
    valueTimes: {
      type: Number,
      default: 60
    },
    timeSetDialogVisible: {
      type: Boolean,
      default: false
    },
    isSave: {
      type: Boolean,
      default: false
    },
    // 1中类显示 2小类显示
    searchFlag: {
      type: Number,
      default: 0
    },
    timeFiveValue: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      type: 60,
      loadingTime: false,
      redioTypes: 0, // 默认小类 0小类 1中类
      timeFive: "17:00"//new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate() + 1, 17, 0)
    }
  },

  methods: {
    changeType () {
      this.closeClassSet(this.redioTypes)
    },
    // 实时库存、销售查询时段设置
    saveRealTime () {
      let that = this
      if (!that.isSave) {
        that.loadingTime = true
        let data = { minutes: that.type }
        that.setRealTime(data).then(res => {
          Message({
            message: "时间段设置成功",
            type: "success"
          });
          that.closeTimeSet(that.type)
        }, err => {
          that.loadingTime = false
          console.log(err)
        })
      } else {
        that.closeTimeSet(that.type)
      }
    },
    // 实时库存、销售查询时段设置
    setRealTime (data) {
      return new Promise((resolve, reject) => {
        setApi
          .setRealTime(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    closeClassSet (searchFlag = null) {
      this.$emit("close_classSet", searchFlag)
    },
    closeTimeSet (time = null) {
      this.$emit("close_timeSet", time)
    },
    timeFiveChange () {
      this.$emit("close_timeFiveSet", this.timeFive)
    }
  },
  mounted () {
  },
  watch: {
    // 路由变化
    timeSetDialogVisible (val) {
      if (val) {
        let that = this
        that.type = that.valueTimes
        that.redioTypes = that.searchFlag
        that.loadingTime = false
        that.timeFive = timeFiveValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/timeSet.vue